import { useLoaderData } from '@remix-run/react'
import type { loader } from './_layout'

export default function SubdomainIndex() {
	const { multiSiteChurch, churches, ministries } = useLoaderData<typeof loader>()

	return (
		<div className="mt-8">
			<div className="text-center">
				<h2 className="text-3xl font-bold text-gray-900">
					Welcome to {multiSiteChurch.name}
				</h2>
				<p className="mt-4 text-lg text-gray-600">
					Explore our churches and ministries
				</p>
			</div>
		</div>
	)
}
